import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = {
  class: "upload_body"
};
const _hoisted_2 = {
  class: "navbat"
};
const _hoisted_3 = {
  class: "upload_body_nr"
};
const _hoisted_4 = {
  class: "upload_list"
};
const _hoisted_5 = {
  key: 0,
  style: {
    "width": "40rem",
    "margin-top": "20%"
  },
  src: "https://www.mimodental.com/assets/imgData/img/new/que.png"
};
const _hoisted_6 = ["onClick"];
const _hoisted_7 = ["src"];
const _hoisted_8 = {
  style: {
    "margin-bottom": "20px",
    "font-size": "30px"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("img", {
    src: "https://www.mimodental.com/assets/imgData/imgs/fh.png",
    alt: "",
    onClick: _cache[0] || (_cache[0] = (...args) => $setup.fh && $setup.fh(...args))
  }), _cache[1] || (_cache[1] = _createElementVNode("span", null, "檬友分享", -1))]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [$setup.upList.length == 0 ? (_openBlock(), _createElementBlock("img", _hoisted_5)) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.upList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      onClick: $event => $setup.go(item.id)
    }, [_createElementVNode("img", {
      src: item.caseTitleUrl,
      style: {
        "object-fit": "cover"
      },
      alt: ""
    }, null, 8, _hoisted_7), _createElementVNode("div", null, [_createElementVNode("div", null, [_createElementVNode("h3", _hoisted_8, _toDisplayString(item.caseTitleName), 1), _createElementVNode("span", null, _toDisplayString(item.searchValue), 1)])])], 8, _hoisted_6);
  }), 128))])])]);
}